<div class="user-panel">
  <div class="user-info">
    <i class="dx-icon dx-icon-user dx-theme-background-color-as-text-color"></i>
    <div class="user-name dx-theme-background-color-as-text-color">{{user?.email}}</div>
  </div>
  @if (menuMode === 'context') {
    <dx-context-menu
      [items]="menuItems"
      target=".user-button"
      showEvent="dxclick"
      width="210px"
    [position]="{
      my: 'top',
      at: 'bottom'
    }"
      cssClass="user-menu">
    </dx-context-menu>
  }
  @if (menuMode === 'list') {
    <dx-list
      class="dx-toolbar-menu-action"
      [items]="menuItems">
    </dx-list>
  }
</div>
